import { useNavigate } from "react-router-dom";
import CustomDropdown from "../Dropdown";
import { useContext } from "react";
import { WellsContext } from "../../../contexts/WellsContext";
import { setCookie } from "../../common/cookiesUpdate/cookies";

interface HeaderInterface {
  home?: string;
  isDropdown?: boolean;
  dropdownOptions?: any[];
  handleSelect?: any;
  selectedOptionsBreadcrumbs?: string;
  defaultValue?: string;
  loginCustomerName?: string;
  handleLogout?: () => void;
  selectedLabel?: string;
}
const Header: React.FC<HeaderInterface> = ({
  home,
  isDropdown,
  dropdownOptions = [],
  handleSelect,
  defaultValue,
  loginCustomerName,
  handleLogout,
  selectedLabel
}) => {
  const navigate = useNavigate();
  const wellsCtx = useContext(WellsContext);
  const ctxOptions = wellsCtx?.wells || [];
  const optionsToUse = dropdownOptions && dropdownOptions.length ? dropdownOptions : ctxOptions;
  return (
    <>
      <header style={{ backgroundColor: "var(--Darkmode-700, #131F2E)" }} className="flex flex-wrap bg-darkcolor-700 text-white px-[15px] py-[12px]">
        <div className="w-full md:w-auto md:flex md:items-center">
          <label
            className="text-primary-400 text-[23px] cursor-pointer"
            onClick={() => {
              setCookie("last_path", "/");
              navigate("/");
            }}
          >
            <span>
              {home}
              {selectedLabel && (
                <>
                  <span className="text-white"> \ </span>
                  {selectedLabel}
                </>
              )}
            </span>
          </label>
          {isDropdown && <label className="text-[23px]">&nbsp;\&nbsp;</label>}
          {isDropdown && (
            <CustomDropdown
              options={optionsToUse}
              onSelect={handleSelect}
              optionHeading="Views"
              dropdownIcon={false}
              bgColor="bg-transparent"
              defaultValue={defaultValue}
              width="320px"
            />
          )}
        </div>
        <div className="flex items-center mt-3 md:mt-0 md:ml-auto">
          <button className="btn btn-primary text-primary-400 text-[15px] mr-2 md:mr-5" style={{ color: "white", textDecoration: "underline" }} onClick={() => handleLogout()}>
            Logout
          </button>
          <p className="text-primary-400 text-[20px] ml-2 md:ml-0">
            {`User: ${loginCustomerName}`}
          </p>
        </div>
      </header >
      <hr className="w-full h-[2px] mx-auto my-0 bg-darkcolor-300 border-0 rounded md:my-0 dark:bg-darkcolor-300" />
    </>

  );
};

export default Header;
